module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAR9JREFUWEftVssNwjAMjdmOE58RUMsAkRAwASCkDEArRuBzYjuMEqiI2ia1jUR6aK/15/nZzzGoxB8kzq8GAA0GEBGOphzb1qx09gAA/KVNXfEaAPammCA+bzYpKDivdZ5JQdjkB1OUqHDh4sFoutH53S+oAWBnTjOFeKmMpCDqyV08gPlWL69RAG2OXBCcGK0q4ASozwfXNyhDbiALROIT3QOcgBzb6AxIKJUmfyuN8MUSWHdfalz5kgDE+uv+fXTOTU5moCKpVdseg1y5sgGEmJBU/l10hBnwTUIsSKpnM5C0BSEl/GUIk8qQsmQoNqFR6+8qllQl8enfcyypQvKABRdR8pMs+VHadUYzN7e7kmJnPvk55iam2g8AkjPwAn5RsjAMWnS9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.png
// module id = q6r7
// module chunks = 0